import { c as _c } from "react/compiler-runtime";
import { cn } from '@repo/ui/lib/utils';
import { HISTORY_WIDE_GRID_CLASS } from './history-constants.ts';
export const HistoryTableHeader = () => {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = cn("hidden gap-2 px-4 py-2 text-sm font-normal text-muted-foreground @4xl/history:grid", HISTORY_WIDE_GRID_CLASS);
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className={t0} data-sentry-component="HistoryTableHeader" data-sentry-source-file="history-table-header.tsx"><span>Action</span><span>Field</span><span>Previous value</span><span aria-hidden="true" /><span>New value</span><span className="text-right">Changed by</span></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};